var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer px-4"},[_c('b-row',{staticClass:"justify-content-lg-between",attrs:{"align-v":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }